import React, { useContext, useState, useEffect } from "react";
import { PostsContext } from "../context/PostsContext";
import OffCanvas from "../components/global/OffCanvas";
import ProfileInfo from "../components/profile/ProfileInfo";
import { ThreadsContext } from "../context/ThreadsContext";
import Posts from "../components/posts/Posts";
import VideoTeaser from "../components/videos/VideoTeaser";
import { VideosContext } from "../context/VideosContext";

const Comunidad = () => {
  const [videoId, setVideoId] = useState(null);
  const [threadId, setThreadId] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [showOffCanvas, setShowOffCanvas] = useState(false);

  const { max, posts, setPost, getPosts } = useContext(PostsContext);
  const { video, setVideo, getSingleVideo } = useContext(VideosContext);
  const { thread, setThread, getSingleThread } = useContext(ThreadsContext);

  useEffect(() => {
    getPosts();
    return clearOffcanvas;
  }, []);

  useEffect(() => {
    if (videoId && videoId !== null) {
      getSingleVideo(videoId);
      setShowOffCanvas(true);
    }
  }, [videoId]);

  useEffect(() => {
    if (customer !== null && !showOffCanvas) {
      setShowOffCanvas(true);
    }
  }, [customer]);

  useEffect(() => {
    if (!showOffCanvas) {
      clearOffcanvas();
    }
  }, [showOffCanvas]);

  useEffect(() => {
    if (threadId !== null) {
      getSingleThread(threadId);
      setShowOffCanvas(true);
    }
  }, [threadId]);

  const clearOffcanvas = () => {
    setCustomer(null);
    setThreadId(null);
    setVideoId(null);
    setThread(null);
    setVideo(null);
    setPost(null);
  };

  const renderOffCanvasContent = () => {
    if (video !== null) {
      return <VideoTeaser video={video} />;
    }
    if (thread !== null) {
      return (
        <Posts
          max={max}
          hideReplies
          title="Hilo"
          posts={thread.posts}
          handleThread={setThreadId}
        />
      );
    }
    if (customer !== null) {
      return <ProfileInfo customer={customer} />;
    }
  };

  return (
    <div id="posts" className="container-fluid px-4 px-md-5">
      <Posts
        max={max}
        fullHeight
        posts={posts}
        title="Comunidad"
        setCustomer={setCustomer}
        handleVideo={setVideoId}
        handleThread={setThreadId}
      />
      <OffCanvas
        showOffCanvas={showOffCanvas}
        setShowOffCanvas={setShowOffCanvas}
      >
        {renderOffCanvasContent()}
      </OffCanvas>
    </div>
  );
};

export default Comunidad;
